var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('zoom-info-form',{ref:"infoFormRefs",attrs:{"form-props":_vm.form,"is-edit":true,"title":"zoom_meeting.zoom_meeting_detail"},on:{"generateNewZoom":_vm.generateNewZoom,"submitForm":_vm.editForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }